import React from 'react';
import { useTranslation } from 'react-i18next';
import Close from '../../../../../Icons/16x16/Close';

import LargeInputIconButton, { type LargeInputIconButtonProps } from '../LargeInputIconButton';

interface Props extends Omit<LargeInputIconButtonProps, 'aria-label' | 'icon' | 'size'> {}

const ClearButton: React.FC<Props> = props => {
  const { t } = useTranslation();
  return (
    <LargeInputIconButton aria-label={t('common.clear')} icon={Close} size="small" {...props} />
  );
};

ClearButton.displayName = 'ClearButton';

export default ClearButton;
